export function AgeFormmatter(dateString: string) {
  const [year, month, day] = dateString.split('-').map(Number)
  const formattedDate = new Date(year, month - 1, day)

  return formattedDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
}
